import React from 'react';
import { theme } from '../../styles/theme';
import { formatSqft } from '../../utils/sizeEstimate';

// Note on a cart line whose price is an estimate because each piece varies in
// size (`approx_sqft` comes from the cart availability check).
const SizeEstimateNote = ({ approxSqft }) => {
  if (!approxSqft) return null;
  return (
    <div
      style={{
        margin: `${theme.spacing.xs} 0 ${theme.spacing.sm}`,
        padding: '8px 10px',
        borderRadius: theme.borderRadius.md,
        border: '1px solid #FCD34D',
        backgroundColor: '#FFFBEB',
        color: '#92400E',
        fontSize: theme.typography.fontSize.xs,
        lineHeight: 1.4,
      }}
    >
      <strong style={{ display: 'block' }}>Estimated price</strong>
      Pieces vary in size (about {formatSqft(approxSqft)} sq ft each). Your final price is based on the actual size of the pieces you receive.
    </div>
  );
};

export default SizeEstimateNote;
